import { getData } from "../../api";

// Blog
export const whyChoose = async (id) => {
  try {
    return await getData(`/without-login/about-us/why-choose?type=${id || ""}`);
  } catch (error) {
    console.log(error);
  }
};

export const OurMission = async (id) => {
  try {
    return await getData(`/without-login/about-us/our-mission`);
  } catch (error) {
    console.log(error);
  }
};

export const ReviewCount = async (id) => {
  try {
    return await getData(`/without-login/about-us/all-review_count`);
  } catch (error) {
    console.log(error);
  }
};

// Faq

export const TeamAbout = async (id) => {
  try {
    return await getData(`/without-login/about-us/all-our-team`);
  } catch (error) {
    console.log(error);
  }
};

export const AboutusAbout = async (id) => {
  try {
    return await getData(`/without-login/about-us/about`);
  } catch (error) {
    console.log(error);
  }
};

export const Counter = async (id) => {
  try {
    return await getData(`/about-us/counter`);
  } catch (error) {
    console.log(error);
  }
};
